module.exports = __webpack_public_path__ + "static/media/company-profile-ad2.43912685.png";